import { createWebHistory, createRouter } from "vue-router";
import Home from "../components/Home";
import Test from "../components/Test";
import Board from "../components/Board";

const routes = [
    {
        path: '/',
        name: 'Time Tracker',
        component: Home
    },
    {
        path: '/test',
        name: 'Test',
        component: Test
    },
    {
        path: '/board',
        name: 'Board',
        component: Board
    }
]

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    routes,
});

export default router;
